import { writable } from 'svelte/store'

function createStore() {
    const { subscribe, update } = writable()

    return {
        subscribe,
        update: (data) => {
            update((store) => {
                if (!store) store = {}
                store = { ...store, ...data }
                return store
            })
        },
    }
}

export const activeMediaStore = createStore()
